import { takeEvery, put, call } from 'redux-saga/effects';
import * as types from '../constants/ActionTypes';
import Api from '../functions/Api';

export function* fetchAnalyticsOrders(payload) {
  try {
    const params = {};
    if (payload.date_from) params.date_from = payload.date_from;
    if (payload.date_to) params.date_to = payload.date_to;
    if (payload.product_id) params.product_id = payload.product_id;
    if (payload.role) params.role = payload.role;
    if (payload.page) params.page = payload.page;
    if (payload.page_size) params.page_size = payload.page_size;

    const query = Object.keys(params).length
      ? `?${new URLSearchParams(params).toString()}`
      : '';
    const response = yield call(
      Api.get,
      `v1/dashboard/analytics/orders/${query}`
    );
    const data = response?.data ?? response ?? {};
    const rows = Array.isArray(data) ? data : data.results || [];
    const totalCount = Number.isFinite(Number(data?.count))
      ? Number(data.count)
      : rows.length;
    yield put({
      type: types.FETCH_ANALYTICS_ORDERS_SUCCESS,
      rows,
      totalCount,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_ANALYTICS_ORDERS_FAILURE,
      error: 'fetchingAnalyticsOrdersError',
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* fetchAnalyticsSummary(payload) {
  try {
    const params = {};
    if (payload.date_from) params.date_from = payload.date_from;
    if (payload.date_to) params.date_to = payload.date_to;
    if (payload.product_id) params.product_id = payload.product_id;
    if (payload.role) params.role = payload.role;

    const query = Object.keys(params).length
      ? `?${new URLSearchParams(params).toString()}`
      : '';
    const response = yield call(
      Api.get,
      `v1/dashboard/analytics/summary/${query}`
    );
    const data = response?.data ?? response ?? {};
    yield put({
      type: types.FETCH_ANALYTICS_SUMMARY_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_ANALYTICS_SUMMARY_FAILURE,
      error: 'fetchingAnalyticsSummaryError',
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* fetchAnalyticsProducts(payload) {
  try {
    const params = {};
    if (payload.search) params.search = payload.search;
    if (payload.role) params.role = payload.role;

    const query = Object.keys(params).length
      ? `?${new URLSearchParams(params).toString()}`
      : '';
    const response = yield call(
      Api.get,
      `v1/dashboard/analytics/products/${query}`
    );
    const data = response?.data ?? response ?? {};
    const items = Array.isArray(data) ? data : data.results || [];
    yield put({
      type: types.FETCH_ANALYTICS_PRODUCTS_SUCCESS,
      items,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_ANALYTICS_PRODUCTS_FAILURE,
      error: 'fetchingAnalyticsProductsError',
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export default function* watchReferal() {
  yield takeEvery(types.FETCH_ANALYTICS_ORDERS, fetchAnalyticsOrders);
  yield takeEvery(types.FETCH_ANALYTICS_SUMMARY, fetchAnalyticsSummary);
  yield takeEvery(types.FETCH_ANALYTICS_PRODUCTS, fetchAnalyticsProducts);
}
